import type AiCostLimitView from '@UI/Store/AiCostLimits/Views/AiCostLimitView';
import type * as React from 'react';
import { Tag } from '@verclam/ui-kit';

type Props = {
	readonly limit: AiCostLimitView;
};

/** The server's state label with its percentage; `warning` for the alert, `danger` once blocking. */
const LimitStatusTag: React.FC<Props> = ({ limit }) => {
	return <Tag value={`${limit.stateLabel} (${limit.percent} %)`} severity={limit.statusSeverity} rounded />;
};

export default LimitStatusTag;
